import { render, staticRenderFns } from "./SaveToDropbox.vue?vue&type=template&id=9fa40c32&"
import script from "./SaveToDropbox.vue?vue&type=script&lang=js&"
export * from "./SaveToDropbox.vue?vue&type=script&lang=js&"
import style0 from "./SaveToDropbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports